import React, { useState } from "react";
import '../SupplyOrder.css'

const CollectionDialog = ({ isOpen, onClose, collectionAmount, setCollectionAmount, handleSubmit }) => {
    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h5>Collection Amount</h5>
                <hr />
                <div className="row">
                    <div className="col-md-12 mb-2">
                        Amount <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                        <input 
                            type="number"
                            className={"form-control registerEmp__textbox"}
                            name="Compostions" 
                            autoComplete="none"
                            required
                            value={collectionAmount}
                            onChange={(e) => setCollectionAmount(e.target.value)} />
                    </div>
                </div>
                <div className="popup-actions">
                    <button onClick={onClose} className="close-btn">Close</button>
                    <button onClick={handleSubmit} className="submit-btn">Submit</button>
                </div>
            </div>
        </div>
    );
};

export default CollectionDialog;